// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rp-0";